module.exports = __webpack_public_path__ + "assets/img/ic-export-blue.026a28d9.svg";